var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('PageHeader',{attrs:{"title":_vm.$tc('app.plan', 2)}}),_c('section',{staticClass:"page-content container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('admin-plans-card',{ref:"plans"})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }